import actionTypes from '../constants/action-types';

const updatePageBinding = (pageId, bindingId, updates) => ({
  type: actionTypes.UPDATE_BINDING,
  payload: { pageId, bindingId, updates },
});

export default updatePageBinding;
